import React from 'react';
import RecordInstruction from '../assesment/utils/test/recordInstruction';
import { setShowPermitMic } from '../../redux/utilities/utils.actions';
import Modal from 'react-bootstrap/Modal';

import { connect } from 'react-redux';

const PermitMicModal = ({ showPermitMic, setShowPermitMic }) => {
	return (
		<Modal
			show={showPermitMic}
			dialogClassName="modal-90w"
			onHide={() => setShowPermitMic(false)}
			backdrop="static"
			keyboard={false}
		>
			<Modal.Header closeButton></Modal.Header>
			<Modal.Body size="lg">
				<RecordInstruction />
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { showPermitMic } = state.rootReducer.utils;
	return {
		showPermitMic,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		setShowPermitMic: (val) => dispatch(setShowPermitMic(val)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(PermitMicModal);
